import { t } from '@/i18n'
/**
 * 用户类型枚举
 */
export enum UserType {
  CLIENT = 1,
  TENANT = 2,
  PLATFORM = 3,
}

/**
 * 数据权限范围类型枚举
 * 对应后端 DataScopeType
 */
export const DataScopeTypeEnum = {
  ALL: {
    value: 'ALL',
    get label() {
      return t('advancedFilter.enums.dataScopeType.all')
    }
  },
  BRANCH: {
    value: 'BRANCH',
    get label() {
      return t('advancedFilter.enums.dataScopeType.branch')
    }
  },
  DEPARTMENT: {
    value: 'DEPARTMENT',
    get label() {
      return t('advancedFilter.enums.dataScopeType.department')
    }
  },
  PERSONAL: {
    value: 'PERSONAL',
    get label() {
      return t('advancedFilter.enums.dataScopeType.personal')
    }
  }
} as const

export type DataScopeTypeValue = typeof DataScopeTypeEnum[keyof typeof DataScopeTypeEnum]['value']

/**
 * 用户角色枚举
 */
export enum RoleType {
  ADMIN = 1,
  NORMAL = 2,
}

/**
 * 来源页面枚举
 */
export enum SourceFrom {
  HOME = 'home',
  PORTAL = 'portal',
  PORTAL_NEW = 'portalnew'
}

/**
 * 数据操作权限类型枚举
 * 对应后端 OperationType
 */
export enum OperationType {
  EDIT = 'EDIT',
  DELETE = 'DELETE',
}

/**
 * 控制塔路径枚举
 */
export enum ControlTowerPath {
  // 认证相关路径
  AUTH_TENANT = '/auth/tenant',
  AUTH_STAFF = '/auth/staff',
  AUTH_PORTAL = '/auth/portal',
  //首页
  DASHBOARD = '/dashboard',
  // 个人中心
  PROFile = '/user-center/profile',
  // 企业信息
  COMPANY_PROFILE = '/user-center/company-profile'
}
